module.exports = __webpack_public_path__ + "static/img/taiHeImg2.5d4a8f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiHeImg2.jpg
// module id = q+44
// module chunks = 2